import React, { useContext } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import * as styles from "./InstallStyles.scss";
import { Title } from "@yoast/ui-library";
import { InstallContext } from "./InstallContext";
import classNames from "classnames";
import { StepNavigation } from "./StepNavigation";
import { SubscriptionDetailProvider } from "../../context/SubscriptionDetailContext";
import { SubscriptionDownloadableSetup } from "./SubscriptionDownloadableSetup";

const messages = defineMessages( {
	title: {
		id: "downloading.title",
		defaultMessage: "Let's connect your site(s) to your product(s)!",
	},
	introductionText: {
		id: "downloading.introductionText",
		defaultMessage: "Thank you for your purchase! Now it's time to set everything up on the site(s) of your choice. " +
			"Connect your site(s) below, then download your product(s) that need to be installed on your site.",
	},
	stepOneTitle: {
		id: "downloading.stepOneTitle",
		defaultMessage: "Step 1: Connect your site(s)",
	},
	stepOneDescription: {
		id: "downloading.stepOneDescription",
		defaultMessage: "Click 'Add site' and enter your site URL to connect it to your product.",
	},
	stepTwoTitle: {
		id: "downloading.stepTwoTitle",
		defaultMessage: "Step 2: Download your product(s)",
	},
	stepTwoDescription: {
		id: "downloading.stepTwoDescription",
		defaultMessage: "Find our purchased product(s) below and click 'Download'.",
	},
} );


/**
 * Renders the ConnectYourSiteStep component.
 * @returns {Element} The rendered component.
 */
export const ConnectYourSiteStep = () => {
	const { subscriptionsWithDownloadables } = useContext( InstallContext );

	return <div className={ classNames( styles.downloadingStep, styles.ySpacing ) }>
		<Title className={ styles.textCenter }><FormattedMessage { ...messages.title } /></Title>
		<hr />
		<div>
			<p>
				<FormattedMessage { ...messages.introductionText } />
			</p>
			<p className={ "yst-mt-4" }>
				<span className={ "yst-font-bold" }><FormattedMessage { ...messages.stepOneTitle } /></span><br />
				<FormattedMessage { ...messages.stepOneDescription } />
			</p>
			<p className={ "yst-mt-4" }>
				<span className={ "yst-font-bold" }><FormattedMessage { ...messages.stepTwoTitle } /></span><br />
				<FormattedMessage { ...messages.stepTwoDescription } />
			</p>
		</div>

		{ subscriptionsWithDownloadables.map( ( { subscriptionId, productName, subscriptionNumber } ) => {
			return <SubscriptionDetailProvider key={ subscriptionId } subscriptionId={ subscriptionId }>
				<SubscriptionDownloadableSetup productName={ productName } subscriptionNumber={ subscriptionNumber } />
			</SubscriptionDetailProvider>;
		} ) }

		<hr />
		<StepNavigation />
	</div>;
};
